import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Input from './Input';

const FieldWrapper = props => (
  <Field
    name={props.name}
    render={({ field, form, ...rest }) => {
      const hasError = form.touched[field.name] && form.errors[field.name];
      const isValid = form.touched[field.name] && !form.errors[field.name];
      const helperText = hasError ? form.errors[field.name] : props.helperText;
      const value = field.value === 'undefined' ? '' : field.value;
      return (
        <props.component
          {...field}
          {...props}
          error={hasError}
          value={value}
          valid={isValid}
          invalidFeedback={forms.errros[field.name]}
          helperText={helperText}
        />
      );
    }}
  />
);

FieldWrapper.defaultProps = {
  component: Input,
};

FieldWrapper.propTypes = {};

export default FieldWrapper;
